import { createSelector } from 'reselect';

const selectGlobalDbnAgents = (state: any) => state.globalDbnAgents;

export const selectGlobalDbnAgentsCurrentItem = createSelector([selectGlobalDbnAgents], (globalDbnAgents) => globalDbnAgents.current);

export const selectGlobalDbnAgentsListItems = createSelector([selectGlobalDbnAgents], (globalDbnAgents) => globalDbnAgents.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalDbnAgentsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalDbnAgentsQueryItems = createSelector([selectGlobalDbnAgents], (globalDbnAgents) => globalDbnAgents.query);

export const selectGlobalDbnAgentsCreatedItem = createSelector([selectGlobalDbnAgents], (globalDbnAgents) => globalDbnAgents.create);

export const selectGlobalDbnAgentsUpdatedItem = createSelector([selectGlobalDbnAgents], (globalDbnAgents) => globalDbnAgents.update);

export const selectGlobalDbnAgentsReadItem = createSelector([selectGlobalDbnAgents], (globalDbnAgents) => globalDbnAgents.read);

export const selectGlobalDbnAgentsDeletedItem = createSelector([selectGlobalDbnAgents], (globalDbnAgents) => globalDbnAgents.delete);

export const selectGlobalDbnAgentsSearchedItems = createSelector([selectGlobalDbnAgents], (globalDbnAgents) => globalDbnAgents.search);

export const selectGlobalDbnAgentsItemsCount = createSelector([selectGlobalDbnAgents], (globalDbnAgents) => globalDbnAgents.count);

export const selectGlobalDbnAgentsItemsFilter = createSelector([selectGlobalDbnAgents], (globalDbnAgents) => globalDbnAgents.filter);